import type { GameContext, GameMiddleware } from "./types";

/**
 * Ensures networking globals (netLogin, netWorld, netGame, netConsole) are
 * initialised on window.  The actual client instances are created on-demand by
 * the login/game states; this middleware just guarantees the slots exist.
 *
 * In the editor's preview mode this enables the state machine to perform
 * network operations without crashing on undefined globals.
 */
export class NetworkingMiddleware implements GameMiddleware {
    init(_ctx: GameContext): void {
        if (!("netLogin" in window)) (window as any).netLogin = null;
        if (!("netWorld" in window)) (window as any).netWorld = null;
        if (!("netGame" in window)) (window as any).netGame = null;
    }
}
